const CARD_WIDTH = 1080;
const CARD_HEIGHT = 1350;
const MAX_RESULT_ROWS = 18;

function escapeSvg(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function shortText(value, max = 40) {
  const text = String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  return text.length > max ? text.slice(0, Math.max(0, max - 3)).trimEnd() + "..." : text;
}

function isPickGame(game) {
  return String(game || "").toLowerCase().startsWith("pick");
}

function numbersFromRow(row) {
  if (Array.isArray(row)) return row;
  if (Array.isArray(row?.numbers)) return row.numbers;
  return [];
}

function numberLine(row, game) {
  return numbersFromRow(row)
    .map(value => {
      const text = String(value).trim();
      return isPickGame(game) ? text : text.padStart(2, "0");
    })
    .join("-");
}

function fireballIconSvg(x, y) {
  return `<g data-fireball-icon="true" transform="translate(${x} ${y})"><path d="M15 34C6 31 1 24 3 15c1-5 4-9 8-13 0 6 3 9 6 11 2-5 5-9 10-13 0 8 5 12 8 18 5 10-2 20-12 17 4-3 5-8 2-13-2 4-5 6-9 8 1-4 0-7-3-10-3 5-3 10 2 14Z" fill="#ff6b00"/><path d="M18 34c-5-2-7-6-6-10 1-3 3-5 6-8 0 4 2 6 4 7 1-3 3-5 6-7 0 5 3 7 5 11 2 6-2 10-8 9 2-2 3-5 1-8-2 3-4 5-8 6Z" fill="#ffb000"/></g>`;
}

function renderPlayedNumberGrid({ rows, game, totalRows, rowFireballs = [] }) {
  const rendered = (Array.isArray(rows) ? rows : []).slice(0, MAX_RESULT_ROWS);
  const columns = 3;
  const perColumn = Math.max(1, Math.ceil(rendered.length / columns));
  const rowHeight = 45;
  const colWidth = 292;
  const xStart = 126;
  const yStart = 764;
  const body = rendered.map((row, i) => {
    const col = Math.floor(i / perColumn);
    const idx = i - col * perColumn;
    const x = xStart + col * colWidth;
    const y = yStart + idx * rowHeight;
    const digits = numberLine(row, game);
    const hasFireball = !!rowFireballs[i];
    const compatibilityMarker = hasFireball ? `<tspan dx="0" font-size="0" fill="transparent">&#128293;</tspan>` : "";
    const fireballMark = hasFireball ? fireballIconSvg(x + 64 + Math.min(178, digits.length * 12 + 6), y - 32) : "";
    return `<rect x="${x}" y="${y - 24}" width="50" height="29" rx="10" fill="#D4AF37"/><text x="${x + 25}" y="${y - 3}" text-anchor="middle" font-family="Arial, sans-serif" font-size="17" font-weight="900" fill="#002855">#${i + 1}</text><text x="${x + 64}" y="${y - 3}" font-family="Arial, sans-serif" font-size="22" font-weight="900" fill="#ffffff">${escapeSvg(digits)}${compatibilityMarker}</text>${fireballMark}`;
  }).join("");
  return {
    shown: rendered.length,
    total: Number(totalRows) || rendered.length,
    svg: body,
  };
}

function renderMetricBox({ x, y, label, value, width = 270, valueFill = "#002855" }) {
  return `<rect x="${x}" y="${y}" width="${width}" height="116" rx="24" fill="#ffffff"/><text x="${x + 24}" y="${y + 40}" font-family="Arial, sans-serif" font-size="17" font-weight="900" fill="#667">${escapeSvg(label)}</text><text x="${x + 24}" y="${y + 88}" font-family="Arial, sans-serif" font-size="34" font-weight="900" fill="${escapeSvg(valueFill)}">${escapeSvg(shortText(value, 18))}</text>`;
}

function renderCanonicalCardB(input = {}) {
  const accent = input.accent || "#008577";
  const game = input.game || "";
  const rows = Array.isArray(input.rows) ? input.rows : [];
  const numbers = renderPlayedNumberGrid({
    rows,
    game,
    totalRows: input.numbersTotal || rows.length,
    rowFireballs: input.rowFireballs || [],
  });
  const footerLink = String(input.footerLink || input.link || "www.lottotracker.app").replace(/^https?:\/\//, "");
  const officialLine = numberLine(input.officialNumbers || [], game);
  const fireball = input.officialFireball !== undefined && input.officialFireball !== null && input.officialFireball !== ""
    ? `  FB ${escapeSvg(input.officialFireball)}`
    : "";
  const outcome = shortText(input.verdict || "Result", 22);
  const explanation = shortText(input.explanation || input.note || "I post the misses too.", 74);
  const fireballUnavailable = String(input.fireballStatus || "").toLowerCase() === "unavailable";
  const verification = fireballUnavailable
    ? "Official base numbers verified / Fireball result unavailable"
    : input.verificationLabel && input.verificationTime
    ? `${input.verificationLabel} - Lineup saved at ${input.verificationTime}`
    : "";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${CARD_WIDTH}" height="${CARD_HEIGHT}" viewBox="0 0 ${CARD_WIDTH} ${CARD_HEIGHT}">
  <defs><linearGradient id="bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#002855"/><stop offset=".62" stop-color="#073b68"/><stop offset="1" stop-color="${escapeSvg(accent)}"/></linearGradient></defs>
  <rect width="${CARD_WIDTH}" height="${CARD_HEIGHT}" rx="58" fill="url(#bg)"/>
  <rect x="62" y="62" width="956" height="1226" rx="46" fill="#fffaf0" opacity=".99"/>
  <text x="110" y="158" font-family="Arial, sans-serif" font-size="48" font-weight="800" fill="#002855">Lotto<tspan fill="#D4AF37">Tracker</tspan></text>
  <text x="110" y="216" font-family="Arial, sans-serif" font-size="24" font-weight="800" fill="#008577" letter-spacing="5">WHAT HAPPENED</text>
  <text x="110" y="305" font-family="Arial, sans-serif" font-size="56" font-weight="900" fill="#002855">${escapeSvg(shortText(input.strategyName || "LottoTracker Result", 31))}</text>
  <text x="110" y="360" font-family="Arial, sans-serif" font-size="32" font-weight="900" fill="${escapeSvg(accent)}">${escapeSvg(shortText(input.gameLine || game, 52))}</text>
  <rect x="110" y="392" width="396" height="122" rx="26" fill="${escapeSvg(input.verdictColor || accent)}"/><text x="138" y="437" font-family="Arial, sans-serif" font-size="18" font-weight="900" fill="#ffffff">VERDICT</text><text x="138" y="485" font-family="Arial, sans-serif" font-size="39" font-weight="900" fill="#ffffff">${escapeSvg(outcome)}</text>
  <rect x="532" y="392" width="444" height="122" rx="26" fill="#ffffff"/><text x="560" y="437" font-family="Arial, sans-serif" font-size="18" font-weight="900" fill="#667">OFFICIAL NUMBERS</text><text x="560" y="485" font-family="Arial, sans-serif" font-size="35" font-weight="900" fill="#002855">${escapeSvg(officialLine || "Pending")}${fireball}</text>
  ${renderMetricBox({ x: 110, y: 544, label: "PLAYED", value: input.amountPlayed || "$0" })}
  ${renderMetricBox({ x: 405, y: 544, label: "WON", value: input.amountWon || "$0", valueFill: "#008577" })}
  ${renderMetricBox({ x: 700, y: 544, width: 276, label: "BEST MATCH", value: input.bestMatch || "0 / 0" })}
  <text x="110" y="680" font-family="Arial, sans-serif" font-size="21" font-weight="900" fill="#555">${escapeSvg(shortText(input.rulesLine || "", 68))}</text>
  <rect x="104" y="698" width="872" height="390" rx="28" fill="#002855"/>
  <text x="126" y="724" font-family="Arial, sans-serif" font-size="21" font-weight="900" fill="#008577">EXACT NUMBERS PLAYED - ${numbers.shown} of ${numbers.total} shown</text>
  ${numbers.svg}
  <text x="110" y="1146" font-family="Arial, sans-serif" font-size="25" font-weight="900" fill="#002855">${escapeSvg(explanation)}</text>
  ${verification ? `<text x="110" y="1195" font-family="Arial, sans-serif" font-size="20" font-weight="900" fill="#008577">${escapeSvg(verification)}</text>` : ""}
  <text x="110" y="1239" font-family="Arial, sans-serif" font-size="24" font-weight="900" fill="#002855">I post the misses too.</text>
  <text x="470" y="1239" font-family="Arial, sans-serif" font-size="21" font-weight="900" fill="#008577">${escapeSvg(shortText(footerLink, 42))}</text>
  <text x="110" y="1278" font-family="Arial, sans-serif" font-size="18" font-weight="700" fill="#5a4a00">No ticket sales. No gambling. No money handled.</text>
</svg>`;
}

module.exports = {
  MAX_RESULT_ROWS,
  renderCanonicalCardB,
};
